import {
  Mesh,
  MeshBasicMaterial,
  OctahedronGeometry,
  PointLight,
} from 'three';

const geometry = new OctahedronGeometry(0.34, 0);

let droneState = null;

export function initDrones(world, options = {}) {
  droneState = {
    world,
    drones: [],
    color: options.color ?? 0x53ffb5,
  };
  return droneState;
}

export function getDrones() {
  if (!droneState) {
    throw new Error('[drones] initDrones() must run before getDrones().');
  }
  return droneState.drones;
}

export function ensureDrones(count, options = {}) {
  const state = droneState;
  if (!state) throw new Error('[drones] initDrones() must run before ensureDrones().');

  while (state.drones.length < count) {
    const drone = createDrone(options);
    state.world.particleRoot.add(drone.mesh);
    state.drones.push(drone);
  }

  while (state.drones.length > count) {
    const drone = state.drones.pop();
    state.world.particleRoot.remove(drone.mesh);
  }

  return state.drones;
}

export function updateDrones(dt, options = {}) {
  const state = droneState;
  if (!state) return;

  const {
    player,
    enemies = [],
    damageMultiplier = 1,
    elapsed = 0,
    onHit = null,
  } = options;
  if (!player) return;

  const count = state.drones.length;
  if (!count) return;

  for (let i = 0; i < count; i += 1) {
    const drone = state.drones[i];
    drone.angle += dt * (2.6 + count * 0.18);
    const angle = drone.angle + (i * Math.PI * 2) / count;
    const radius = 2.15 + count * 0.18;
    drone.mesh.position.set(
      player.pos.x + Math.sin(angle) * radius,
      1.25 + Math.sin(elapsed * 5 + i) * 0.16,
      player.pos.z + Math.cos(angle) * radius,
    );
    drone.mesh.rotation.x += dt * 4;
    drone.mesh.rotation.y += dt * 6;
    drone.hit -= dt;

    if (drone.hit > 0) continue;
    for (const enemy of enemies) {
      if (!enemy.alive) continue;
      const dx = enemy.pos.x - drone.mesh.position.x;
      const dz = enemy.pos.z - drone.mesh.position.z;
      if (dx * dx + dz * dz >= (enemy.radius + 0.72) ** 2) continue;

      drone.hit = 0.18;
      onHit?.(enemy, 1.15 * damageMultiplier, drone);
      break;
    }
  }
}

export function clearDrones() {
  const state = droneState;
  if (!state) return;
  for (const drone of state.drones) {
    state.world.particleRoot.remove(drone.mesh);
  }
  state.drones.length = 0;
}

function createDrone(options = {}) {
  const color = options.color ?? droneState.color;
  const mesh = new Mesh(
    geometry,
    new MeshBasicMaterial({ color, transparent: true, opacity: 0.88 }),
  );
  if (options.quality === 'high' || options.quality === 'ultra') {
    mesh.add(new PointLight(color, 0.55, 4.5, 2.2));
  }
  return {
    mesh,
    angle: Math.random() * Math.PI * 2,
    hit: 0,
  };
}
